<template>
  <v-card
    flat
    :style="{
      background: value?.pallete?.headColor ||'#ffff',
      color: value?.pallete?.textColor,
    }"
    class="rounded-0 pb-1 pt-4 mb-0"
    v-intersect="onIntersect"
  >
    <v-row
      :style="{
        color: value.pallete.textColor,
      }"
      no-gutters
      v-for="(item, i) in value.extraFields"
      :key="i"
      class="pt-2 px-5"
    >
      <v-col
        :style="{
          color: value?.pallete?.textColor,
        }"
        cols="12"
        class="d-flex align-start"
        :tag="extraIsLink(item) ? 'a' : 'div'"
        target="_blank"
        :href="extraIsLink(item) ? fixLink(item.link) : false"
        :class="{ 'link-tag': extraIsLink(item) }"
      >
        <span v-if="item.icon" class="text-no-wrap me-1">
          <v-icon :color="value.pallete.textColor">{{ item.icon }}</v-icon>
          :
        </span>
        <pre
          :style="{
            color: value?.pallete?.textColor,
          }"
          v-if="item.value"
          class="text-right mb-0 mt-1"
          :key="i"
          v-html="item.value"
          :class="extraIsLink(item) ? 'link-tag' : ''"
        />
      </v-col>
      <v-col cols="12" class="py-2">
        <v-divider class="my-0" v-show="i + 1 < value.extraFields.length" />
      </v-col>
    </v-row>

    <v-card-text
      :style="{
        color: value.pallete.textColor,
      }"
      v-if="value.website && !['qr.gift','qr.name.gift','qr.name.id,gift','modelsList.memories.edit', 'qr.create.memories'].includes($route.name)"
      class="font-size-h5 d-flex mt-0 pt-3 flex-column"
    >
      <a
        :href="value.website"
        :style="{
          color: value.pallete.textColor,
        }"
      >
        <v-icon class="ml-auto" :color="value.pallete.textColor"
          >mdi-web</v-icon
        >
        {{ value.website }}
      </a>
    </v-card-text>
        <v-card-text
      :style="{
        color: value.pallete.textColor,
      }"
      v-if="value.website && ['qr.gift','qr.name.gift','qr.name.id,gift','modelsList.memories.edit',
                      'qr.create.memories'].includes($route.name)"
      class="font-size-h5 d-flex mt-0 pt-3 flex-column"
    >
      <div
        :style="{
          color: value.pallete.textColor,
        }"
      >
        <v-icon class="ml-auto" :color="value.pallete.textColor"
          >mdi-heart</v-icon
        >
        {{ value.website }}
      </div>
    </v-card-text>



    <v-card-text
      v-if="value.aboutUs"
      class="font-size-h5 d-flex mt-0 pt-3 flex-column"
    >
      <p
        style="white-space: pre-line"
        :style="{
          color: value.pallete.textColor,
        }"
      >
        {{ value.aboutUs }}
      </p>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "showInfo",

  props: {
    value: {},
  },

  data: () => ({
    isIntersecting: false,
  }),

  watch: {
    isIntersecting(val) {
      this.$emit("intersecting", val);
    },
  },

  methods: {
    onIntersect(entries, observer) {
      // More information about these options
      // is located here: https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
      this.isIntersecting = entries[0].isIntersecting;
    },
    extraIsLink(item) {
      return item.link && item.link.length > 0;
    },
    fixLink(link) {
      return link.startsWith("http") ? link : "https://" + link;
    },
  },
};
</script>

<style scoped>
pre {
  font-family: Vazir, serif !important;
  white-space: break-spaces;
  overflow: hidden;
}

.link-tag,
.link-tag .v-icon {
  color: #0985d2;
  cursor: pointer;
}

.link-tag:hover,
.link-tag:hover .v-icon {
  color: #33a9f1;
}
</style>
